export const version = '2.5.2'
